/**
 * Created by miguel on 22/2/17.
 */
/// <reference path="../documents/DocumentListCell.ts" />

class QuotationListCell extends DocumentListCell
{
    awakeFromHTML(){
        super.awakeFromHTML();
    }

    set item(item:QuotationDocument){
        this.setItem(item);
    }

}